//
//
//
//
//
//
//
//

export default {
  name: "measureUnit",
  data: function data() {
    return {
      select: "米",
      dataList: [{
        label: "米"
      }, {
        label: "吨"
      }, {
        label: "平方米"
      }, {
        label: "立方米"
      }, {
        label: "根"
      }, {
        label: "孔"
      }, {
        label: "座"
      }, {
        label: "个"
      }, {
        label: "榀"
      }, {
        label: "块"
      }, {
        label: "套"
      }, {
        label: "段"
      }, {
        label: "樘"
      }, {
        label: "间"
      }, {
        label: "副"
      }, {
        label: "天"
      }, {
        label: "台"
      }, {
        label: "台次"
      }, {
        label: "瓦"
      }]
    };
  },
  props: {
    workLoad: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: "workLoad",
    event: 'inputChange'
  },
  methods: {
    changeSelect: function changeSelect(val) {
      this.select = val;
      console.log(val);
      this.$emit("changeSelect", val);
    },
    input: function input(val) {
      console.log(val);
      this.$emit("inputChange", val);
    }
  }
};